import StorageService from 'tradera/services/storage-service';
import { STORAGE_KEYS } from 'tradera/constants/storage';

const storageService = new StorageService(STORAGE_KEYS.SAVED_SEARCHES);

export const getSavedSearch = (id) => storageService.get(id);

export const storeSavedSearch = (id, data) => storageService.set(id, data);

export const removeSavedSearch = (id) => storageService.remove(id);
